<template>
    <div class="tags--select">

        <!--Tag creation-->
        <section v-if="create_modal">
            <div class="modal fade" id="tag--create-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
                 aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header text-center">
                            <h4 class="modal-title w-100 font-bold">Create Tag</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mx-3">
                            <name_to_slug
                                    ref="tag_name_slug"
                                    :content="content.name_to_slug"></name_to_slug>

                            <div class="md-form">
                                <textarea v-model="tag_create_description" id="tag--create-description"
                                          class="md-textarea"></textarea>
                                <label data-error="wrong" data-success="right"
                                       for="tag--create-description">Description</label>
                            </div>

                            <div id="icon-chooser--wrapper">
                                <icon_chooser
                                        ref="tag_icon"
                                        :icons_url="content.icon_chooser.icons_url"
                                        :input_field="content.icon_chooser.input_field">
                                </icon_chooser>
                            </div>

                        </div>
                        <div class="modal-footer d-flex justify-content-center">
                            <a class="btn btn-default" v-on:click="createTag()">Create</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--Select tags-->
        <section>
            <div>
                <div id="material_select--wrapper">
                    <material-select ref="tags_chooser_select"
                                     :id="tags_chooser.id"
                                     :select_input_id="tags_id_for_chooser"
                                     @material_select_result="materialSelectItemSelected"
                                     @material_select_link_click="materialSelectCreateTag"></material-select>
                </div>
            </div>
        </section>
    </div>
</template>

<style>
    #select-icon-type--scrollable-container {
        height: 25vh;
        overflow-y: scroll;
    }
</style>

<script>
    // add imports here
    import {uniqueId} from '../../helpers/classesAndIds';
    import {_} from 'underscore';
    import MaterialSelect from '../forms/select/MaterialSelect.vue'

    /**
     * Produces a searchable list of icons to display
     */
    export default {
        components: {
            'material-select': MaterialSelect
        },
        props: {
            content: Object,
            tags_id: {
                type: String,
                default: null
            }
        },
        mounted() {
            let self = this;

            self.tags_create_url = self.content.tags_create_url;
            self.tags_read_url = self.content.tags_read_url;
            self.tags_selected = self.content.tags_selected;
            self.tags_id_for_chooser = (typeof self.tags_id !== 'undefined' && self.tags_id !== null) ? self.tags_id : uniqueId('tags_chooser');
            self.loadTags();
        },
        data() {
            return {
                tags_id_for_chooser: null,
                loading: false,
                tags_create_url: '',
                tags_read_url: '',
                tag_create_description: '',
                tags_selected: [],
                tags: [],
                tags_chooser: {
                    id: ''
                },
                create_modal: false
            }
        },
        methods: {

            createTag() {
                let self = this;

                if (self.loading) {
                    return;
                }

                self.loading = true;
                axios.post(self.tags_create_url, {
                    title: self.$refs.tag_name_slug.input_name__value,
                    slug: self.$refs.tag_name_slug.input_slug__value,
                    description: self.tag_create_description,
                    icon: self.$refs.tag_icon.hiddenField.value
                })
                    .then(function (response) {
                        if (response.data.success) {
                            //We did it;
                            $('#tag--create-modal').modal('hide');
                            // console.log(response.data.tag);

                            let new_tag = {
                                id: response.data.tag.id,
                                slug: response.data.tag.slug,
                                lang: response.data.tag.tag_data.lang,
                                icon: response.data.tag.tag_data.icon
                            };

                            self.tags.push(new_tag);

                            self.tags_chooser.select_items = self.tags;
                            self.$refs.tags_chooser_select.addAndSelect(new_tag);
                            self.loading = false;

                            self.create_modal = false;

                        } else {
                            toastr.error('Ops... check all your fields and be sure they are correctly inserted');
                            self.loading = false;
                        }
                    });
            },

            loadTags() {
                let self = this;

                self.loading = true;
                axios.get(self.tags_read_url)
                    .then(function (response) {
                        self.tags = response.data;
                        self.initMaterialSelect([]);
                        self.loading = false;
                    });
            },

            materialSelectCreateTag() {
                let self = this;

                self.create_modal = true;

                self.$nextTick(function () {
                    $('#tag--create-modal')
                        .on('hidden.bs.modal', function () {
                            self.create_modal = false;
                        })
                        .modal('show');
                });
            },

            materialSelectItemSelected(items) {
                let self = this;
                self.tags_selected = [];

                items.forEach(function (item) {
                    self.tags_selected.push(item.optionValue);
                });
            },

            initMaterialSelect: function (groups) {
                let self = this;

                self.tags.forEach(function (tag) {
                    if (self.tags_selected.indexOf(tag.id) !== -1) {
                        tag.selected = true;
                    }
                });


                self.tags_chooser = {
                    params: {
                        multiple: true,
//                        grouped: [],
                        grouped: groups,
                        group_by: '',
                        top_option: {
                            title: 'Add existing tag'
                        },
                        selected_input_name: 'tags_select[]',
                        label: 'Select tags',
                        placeholder: 'No tag selected',
                        id: uniqueId('tags_chooser'),
                        select_input_id:self.tags_id_for_chooser,
                        link: {
                            add: true,
                            url: '',
                            icon: 'fa-plus',
                            text: 'Create a new tag'
                        },
                    },
                    select_items: self.tags
                };
                // console.log('initMaterialSelect',self.tags_chooser);

                // console.log(self.$root);

                // self.$refs.event_chooser_select.$emit('material_select', self.tags_chooser);

                self.$root.$emit('material_select', self.tags_chooser);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/Tags.vue?fb402b92